import React from "react";
import { ClipboardListIcon, FileTextIcon, ListChecksIcon, BookOpenIcon, TableIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { resources } from "../data/landing";
const icons = [ClipboardListIcon, FileTextIcon, ListChecksIcon, BookOpenIcon, TableIcon];
export function Resources() {
  return <Section tone="navy" cta="Get the Complete HOF Clinical Blueprint™" data-id="element-259" data-mp="pku36023sxqm">
      <SectionHeading title="Your Complete Professional Resource Collection" intro="When you purchase HOF CLINICAL BLUEPRINT™, you will receive more than six educational volumes. You will also receive practical reference materials designed around the topics covered in the collection." data-id="element-260" data-mp="tjt6jg86smfy" />

      <ul className="mx-auto mt-12 max-w-3xl divide-y divide-line" data-id="element-261" data-mp="188fl3fpzpa64">
        {resources.map((r, i) => {
        const Icon = icons[i];
        return <li key={r.title} className="flex gap-4 py-5" data-id="element-262" data-mp="1ha5lhb1unjg1" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gold/15 text-gold" data-id="element-263" data-mp="1haoshwpyonfa">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-264" data-mp="78xw3zc1vfde" />
              </span>
              <div data-id="element-265" data-mp="2eaf0ljdln8u">
                <h3 className="text-lg font-bold text-cream sm:text-xl" data-id="element-266" data-mp="3tiimjno0ycqp">{r.title}</h3>
                <p className="mt-1 text-base leading-relaxed text-muted" data-id="element-267" data-mp="3tklc66l9m3uw">{r.text}</p>
              </div>
            </li>;
      })}
      </ul>

      <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-268" data-mp="q0qmdlzqimhf">
        <p className="text-base leading-relaxed text-muted sm:text-lg" data-id="element-269" data-mp="l2p3b12b6n5y">
          Everything is designed to complement the six volumes and help you build a more organized professional
          reference library.
        </p>
        <p className="mt-4 font-serif text-xl font-semibold italic leading-snug text-cream sm:text-2xl" data-id="element-270" data-mp="bdnqfjr28lw7">
          Imagine having a dedicated place for your facial aesthetic safety references, rather than searching through
          disconnected notes whenever you need to review a topic.
        </p>
      </div>
    </Section>;
}